import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface EditEnterpriseInterface {
  id: string;
  enterpriseName: string;
  email: string;
  address: string;
  password: string;
  BRNumber: string;
  phone: string;
  packages: string;
}

export const useEditEnterprise = () => {
  const mutate = useMutation(
    ({
      enterpriseName,
      email,
      address,
      password,
      BRNumber,
      phone,
      id,
      packages,
    }: EditEnterpriseInterface) => {
      let body: any = {};
      if (password) {
        body = {
          enterprise_name: enterpriseName,
          email,
          address,
          new_password: password,
          br_number: BRNumber,
          phone,
          package: packages,
        };
      } else {
        body = {
          enterprise_name: enterpriseName,
          email,
          address,
          br_number: BRNumber,
          phone,
          package: packages,
        };
      }

      return postAPI(`/external-api/update_enterprise_acc/${id}`, body);
    },
  );

  return mutate;
};

export default useEditEnterprise;
